import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../../shared/components/ui/cta-button/cta-button.component';
import { PatrolDiscordBotHealth } from '../../../models/patrol-discord-cockpit.model';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-connect-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe, CtaButtonComponent],
  templateUrl: './patrol-discord-connect-panel.component.html',
  styleUrl: './patrol-discord-connect-panel.component.scss',
})
export class PatrolDiscordConnectPanelComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  botHealth = input.required<PatrolDiscordBotHealth>();
  displayName = input<string>();
  /** When true, guild is linked — hide invite/copy; show refresh (and fix permissions if bot unhealthy). */
  guildConnected = input(false);
  compact = input(false);

  readonly isRefreshing = this.#cockpit.isRefreshing;
  readonly copiedInvite = this.#cockpit.copiedInvite;

  readonly showInviteActions = computed(() => !this.guildConnected());
  readonly showFixPermissions = computed(
    () =>
      this.guildConnected() &&
      (!this.botHealth().ready || Boolean(this.botHealth().startupError)),
  );

  refresh(): void {
    void this.#cockpit.refresh();
  }

  addBot(): void {
    this.#cockpit.openInviteUrl();
  }

  copyInvite(): void {
    void this.#cockpit.copyInviteUrl();
  }
}
